export default __webpack_public_path__ + "static/media/Ping-Pong.9b0d528b.png";